module.exports = __webpack_public_path__ + "static/media/no-buildings.ae79bd3a.svg";